<div class="row">
  <div>
    <form #contactForm="ngForm" (ngSubmit)="onSubmit()">
      <mat-form-field class="input-control">
        <p class="input-label" [class.error]="nameInput.value!=='' && nameInput.dirty && nameInput.errors"
           [class.filledInput]="nameInput.dirty && !nameInput.errors">Full Name*</p>
        <input matInput type="text" pattern="[a-zA-Z ]+" #nameInput="ngModel"
               [(ngModel)]="name" name="name"
               maxlength="100" [errorStateMatcher]="enquireNowMatcher"
               required>
      </mat-form-field>


      <mat-form-field class="input-control">
        <p class="input-label" [class.error]="emailInput.value!=='' && emailInput.dirty && emailInput.errors"
           [class.filledInput]="emailInput.dirty && !emailInput.errors">
          Email ID*</p>
        <input matInput type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #emailInput="ngModel"
               [(ngModel)]="email" name="email" [errorStateMatcher]="enquireNowMatcher" maxlength="60"
               required>
      </mat-form-field>

      <div id="phone-input-section">
            <span class="input-label phone-input"
                  [class.error]="phoneNumberInput.value!=='' && phoneNumberInput.dirty && phoneNumberInput.errors"
                  [class.filledInput]="phoneNumberInput.dirty && !phoneNumberInput.errors">Mobile Number*</span>
        <mat-form-field class="input-control">
          <p matPrefix class="phone-prefix"
             [class.error]="phoneNumberInput.value!=='' && phoneNumberInput.dirty && phoneNumberInput.errors">
            +91</p>
          <input matInput type="text" pattern="[0-9]+" #phoneNumberInput="ngModel" [(ngModel)]="phoneNumber"
                 name="phoneNumber" [errorStateMatcher]="enquireNowMatcher"
                 maxlength="10" minlength="10" required>
        </mat-form-field>
      </div>


      <mat-form-field class="input-control">
        <p class="input-label"
           [class.error]="convenientTimeInput.value!=='' && convenientTimeInput.dirty && convenientTimeInput.errors"
           [class.filledInput]="(convenientTimeInput.dirty && !convenientTimeInput.errors)">
          Convenient time to reach out to you*</p>
        <mat-select #convenientTimeInput="ngModel" [errorStateMatcher]="enquireNowMatcher"
                    [(ngModel)]="convenientTime" name="convenientTime"
                    [class.filledInput]="!(convenientTimeInput.dirty && !convenientTimeInput.errors)"
                    required>
          <mat-option
              value="10am - 8pm">Between 10 am to 8 pm
          </mat-option>
          <mat-option
              value="10am - 1pm">Between 10 am to 1 pm
          </mat-option>
          <mat-option
              value="1pm - 5pm">Between 1 pm to 5 pm
          </mat-option>
          <mat-option
              value="5pm - 8pm">Between 5 pm to 8 pm
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="captcha-container">
        <app-captcha (resolved)="captchaResolved($event)" (error)="captchaError($event)"></app-captcha>
      </div>

      <small [class.error]="!submissionResult" [class.success]="submissionResult">{{submissionMessage}}</small>

      <button mat-flat-button type="submit" [disabled]="!isCaptchaResolved || contactForm.invalid" id="submit" class="col-lg-12 primary pt-1 mt-4">
        SUBMIT
      </button>
    </form>
  </div>
</div>
